import React, { useEffect, useState } from "react";
import SideBar from "./SideBar";
import TopBar from "./TopBar";
import Modal from "react-bootstrap/Modal";
import { fmtDate } from "./aces/Shared";
import { useNavigate } from "react-router-dom";
import { Spinner } from "react-bootstrap";
import { useTranslation } from "react-i18next";

interface Props {
  show?: boolean;
  onPressDetailModal?: () => void;
  onPressUserModal?: () => void;
  usershow?: boolean;
  allList: any[];
  questionList: any;
  responsesList: any[];
  loading: boolean;
  mainLoading: boolean;
  isTemplate: boolean;
  role: string | null;
  dropDownList: any[];
  dropdownLoading: boolean;
  templateDropDown: () => void;
  getResponsesList: (checklistId: number) => Promise<void>;
  getQuestionList: (checklistId: number) => Promise<void>;
  deleteCheckList: (checklistId: number) => Promise<void>;
  navigateToEditTemplate: (item: any) => void;
  navigateToUseTemplate: (item: any) => Promise<void>;
}

const CheckList = ({
  deleteCheckList,
  isTemplate,
  mainLoading,
  show,
  onPressDetailModal,
  onPressUserModal,
  usershow,
  allList,
  loading,
  questionList,
  role,
  responsesList,
  getQuestionList,
  getResponsesList,
  navigateToEditTemplate,
  navigateToUseTemplate,
  templateDropDown,
  dropDownList,
  dropdownLoading,
}: Props) => {
  const navigate = useNavigate();
  const { t } = useTranslation();

  const [selected, setSelected] = useState<any>(null);

  const [searchTitle, setSearchTitle] = useState("");
  const [searchDescription, setSearchDescription] = useState("");
  const [searchPriority, setSearchPriority] = useState("");

  const filteredChecklists = allList.filter((item) => {
    return (
      item.title?.toLowerCase().includes(searchTitle.toLowerCase()) &&
      item.description
        ?.toLowerCase()
        .includes(searchDescription.toLowerCase()) &&
      (searchPriority ? item.priority === searchPriority : true)
    );
  });

  return (
    <>
      <Modal
        show={usershow}
        onHide={onPressUserModal}
        centered
        className="__modal"
        size="lg"
      >
        <Modal.Header closeButton>
          <Modal.Title>{t("checklist.responsesTitle")}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="__defaultTable">
            {responsesList.length > 0 ? (
              <table className="table table-bordered">
                <thead>
                  <tr>
                    <th>{t("checklist.userName")}</th>
                    <th>{t("checklist.email")}</th>
                    <th>{t("checklist.department")}</th>
                    <th>{t("checklist.role")}</th>
                    <th>{t("checklist.status")}</th>
                    <th>{t("checklist.response")}</th>
                  </tr>
                </thead>
                <tbody>
                  {responsesList.map((res, idx) => (
                    <tr key={idx}>
                      <td>{res.user?.name || "N/A"}</td>
                      <td className="email_cell">{res.user?.email || "N/A"}</td>
                      <td>{res.user?.department || "N/A"}</td>
                      <td>{res.user?.role || "N/A"}</td>
                      <td>{res.user?.status || "N/A"}</td>
                      <td>
                        {res.response ? (
                          <a
                            href={res.response}
                            target="_blank"
                            rel="noopener noreferrer"
                          >
                            {t("checklist.submitted")}
                          </a>
                        ) : (
                          t("checklist.not_submitted")
                        )}
                      </td>
                      <td>
                        {res.submissionDate
                          ? fmtDate(res.submissionDate)
                          : "-"}
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            ) : (
              <p className="nofound">{t("checklist.noResponses")}</p>
            )}
          </div>
        </Modal.Body>
      </Modal>

      <Modal
        show={show}
        onHide={onPressDetailModal}
        centered
        className="__modal"
        size="lg"
      >
        <Modal.Header closeButton>
          <Modal.Title>{t("checklist.questionsTitle")}</Modal.Title>
        </Modal.Header>

        <Modal.Body>
          {/* Manager Section */}
          <h5 className="mb-3">{t("checklist.managerQuestions")}</h5>
          <div className="__defaultTable">
            {questionList?.manager?.length > 0 ? (
              <table className="table table-bordered">
                <thead>
                  <tr>
                    <th>{t("checklist.id")}</th>
                    <th>{t("checklist.title")}</th>
                    <th>{t("checklist.answer")}</th>
                    <th>{t("checklist.note")}</th>
                    <th>{t("checklist.updatedAt")}</th>
                  </tr>
                </thead>
                <tbody>
                  {questionList.manager.map((q: any, idx: number) => (
                    <tr key={`manager-${idx}`}>
                      <td>{q.id}</td>
                      <td>{q.title}</td>
                      <td>{q.answer || "-"}</td>
                      <td>{q.note || "-"}</td>
                      <td>
                        {fmtDate(q.updatedAt)}
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            ) : (
              <p>{t("checklist.noManagerQuestions")}</p>
            )}
          </div>
          {/* Employee Section */}
          <h5 className="mt-4 mb-3">{t("checklist.employeeQuestions")}</h5>
          <div className="__defaultTable">
            {questionList?.employee?.length > 0 ? (
              <table className="table table-bordered">
                <thead>
                  <tr>
                    <th>{t("checklist.id")}</th>
                    <th>{t("checklist.title")}</th>
                    <th>{t("checklist.isImageRequired")}</th>
                    <th>{t("checklist.note")}</th>
                    <th>{t("checklist.updatedAt")}</th>
                  </tr>
                </thead>
                <tbody>
                  {questionList.employee.map((q: any, idx: number) => (
                    <tr key={`employee-${idx}`}>
                      <td>{q.id}</td>
                      <td>{q.title}</td>
                      <td>{q.isImage ? t("aces.common.yes") : t("aces.common.no")}</td>
                      <td>{q.note || "-"}</td>
                      <td>
                        {fmtDate(q.updatedAt)}
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            ) : (
              <p>{t("checklist.noEmployeeQuestions")}</p>
            )}
          </div>
        </Modal.Body>
      </Modal>

      <div className="__dashboard">
        <div className="__dashboard__wrapper">
          <SideBar />
          <div className="__dashboardRightSide">
            <TopBar />
            <div className="__dashboardContent">
              <div className="__pageHeading">
                <div className="__pageHeading">
                  {isTemplate
                    ? t("checklist.templateList")
                    : t("checklist.checkList")}
                </div>
              </div>

              <div className="__myTraining">
                {isTemplate && (
                  <div className="createChecklist" style={{ border: "none" }}>
                    <button
                      onClick={() =>
                        navigate("/newchecklist", { state: { isTemplate } })
                      }
                    >
                      {t("checklist.createTemplate")}
                    </button>
                  </div>
                )}
                {!isTemplate && (
                  <div
                    className="checkListDropDown mb-0"
                    style={{ border: "none" }}
                  >
                    {dropdownLoading ? (
                      <div className="createChecklist">
                        <button>
                          <Spinner animation="border" role="status" size="sm">
                            <span className="visually-hidden">Loading...</span>
                          </Spinner>
                        </button>
                      </div>
                    ) : (
                      <div className="createChecklist">
                        <button onClick={() => templateDropDown()}>
                          {t("checklist.createChecklist")}
                        </button>
                      </div>
                    )}

                    {/* drop down here */}

                    {dropDownList.length > 0 && (
                      <div className="dropdownWrapper">
                        <select
                          onChange={(e) => {
                            const selectedId = Number(e.target.value);
                            const selectedItem = dropDownList.find(
                              (item: any) => item.id === selectedId
                            );
                            setSelected(selectedItem);
                          }}
                        >
                          <option value="">
                            {t("common.select_template")}
                          </option>
                          {dropDownList.map((item: any) => (
                            <option key={item.id} value={item.id}>
                              {item.title}
                            </option>
                          ))}
                        </select>

                        {selected && (
                          <button
                            onClick={() => navigateToUseTemplate(selected)}
                            className="refund_btn"
                          >
                            {t("common.use")}
                          </button>
                        )}
                      </div>
                    )}
                  </div>
                )}
                <div className="form__paremt" style={{ border: "none" }}>
                  <div className="row">
                    <div className="__input__group" style={{ width: "32%" }}>
                      <label>{t("checklist.table.title")}</label>
                      <input
                        type="text"
                        placeholder={t("aces.reports.searchTitle")}
                        value={searchTitle}
                        onChange={(e) => setSearchTitle(e.target.value)}
                      />
                    </div>

                    <div className="__input__group" style={{ width: "32%" }}>
                      <label>{t("checklist.table.description")}</label>
                      <input
                        type="text"
                        placeholder={t("aces.reports.searchByDescription")}
                        value={searchDescription}
                        onChange={(e) => setSearchDescription(e.target.value)}
                      />
                    </div>

                    <div className="__input__group" style={{ width: "32%" }}>
                      <label>{t("checklist.table.priority")}</label>
                      <select
                        value={searchPriority}
                        onChange={(e) => setSearchPriority(e.target.value)}
                      >
                        <option value="">{t("dropdown.all")}</option>
                        <option value="High"> {t("checklistForm.high")}</option>
                        <option value="Medium">
                          {t("checklistForm.medium")}
                        </option>
                        <option value="Low">{t("checklistForm.low")}</option>
                      </select>
                    </div>
                  </div>
                </div>
                <div className="row">
                  <div className="col-lg-12 col-12">
                    <div className="__defaultTable">
                      <table>
                        <thead>
                          <tr>
                            <th>{t("checklist.table.title")}</th>
                            <th>{t("checklist.table.description")}</th>
                            <th>{t("checklist.table.dueDate")}</th>
                            <th>{t("checklist.table.priority")}</th>
                            <th>{t("checklist.table.attachment")}</th>
                            <th>{t("checklist.table.updatedAt")}</th>
                            <th>{t("checklist.table.actions")}</th>
                            {isTemplate && <th>{t("checklist.table.edit")}</th>}
                          </tr>
                        </thead>

                        {/* TABLE BODY */}
                        <tbody>
                          {mainLoading ? (
                            <tr>
                              <td colSpan={8} style={{ textAlign: "center" }}>
                                <i
                                  className="ri-loader-4-line ri-spin"
                                  style={{ fontSize: "20px" }}
                                ></i>{" "}
                                {t("aces.reports.loadingChecklists")}
                              </td>
                            </tr>
                          ) : filteredChecklists?.length > 0 ? (
                            filteredChecklists.map((item) => (
                              <tr key={item.id}>
                                <td>{item.title}</td>
                                <td>{item.description}</td>
                                <td style={{ color: "red", fontWeight: "600" }}>
                                  {item.dueDateTime ? (
                                    <>
                                      {fmtDate(item.dueDateTime)}
                                    </>
                                  ) : (
                                    "-"
                                  )}
                                </td>
                                <td>
                                  <span
                                    className={`priorityBtn ${item.priority?.toLowerCase()}Priority`}
                                  >
                                    {t(`checklistForm.${item.priority?.toLowerCase()}`, { defaultValue: item.priority })}
                                  </span>
                                </td>
                                {/* <td>
                                  <i
                                    className={`ri-notification-3-line ${
                                      item.emailReminder
                                        ? "text-success"
                                        : "text-muted"
                                    }`}
                                    title={
                                      item.emailReminder
                                        ? "Reminder On"
                                        : "Reminder Off"
                                    }
                                  ></i>
                                </td> */}
                                {/* <td>
                                  {item.attachments?.length > 0
                                    ? item.attachments.map(
                                        (file: any, index: number) => (
                                          <a
                                            key={file.id || index}
                                            href={file.url}
                                            target="_blank"
                                            rel="noopener noreferrer"
                                            title={`View Attachment ${
                                              index + 1
                                            }`}
                                            style={{ marginRight: "8px" }}
                                          >
                                            <i className="ri-attachment-2"></i>
                                          </a>
                                        )
                                      )
                                    : "-"}
                                </td> */}
                                <td>
                                  {item.attachments?.length > 0 ? (
                                    item.attachments.map(
                                      (file: any, index: number) => (
                                        <a
                                          key={file.id || index}
                                          href={file.url}
                                          target="_blank"
                                          rel="noopener noreferrer"
                                          title={t("aces.a11y.attachment", { n: index + 1 })}
                                          aria-label={t("aces.a11y.attachment", { n: index + 1 })}
                                          className="attachmentIcon"
                                        >
                                          <i className="ri-attachment-2" aria-hidden="true"></i>
                                        </a>
                                      )
                                    )
                                  ) : (
                                    <span className="aces-no-file">
                                      {t("aces.reports.noFile")}
                                    </span>
                                  )}
                                </td>

                                <td>
                                  {fmtDate(item.updatedAt)}
                                </td>
                                <td>
                                  {!loading ? (
                                    <div className="flex-gap">
                                      <button
                                        type="button"
                                        className="aces-table-link"
                                        onClick={() =>
                                          getResponsesList(item.id)
                                        }
                                      >
                                        {t("common.reports")}
                                      </button>
                                      <span className="divider"></span>
                                      <button
                                        type="button"
                                        className="aces-table-link"
                                        onClick={() => getQuestionList(item.id)}
                                      >
                                        {t("templateList.questionsTitle")}
                                      </button>
                                    </div>
                                  ) : (
                                    <Spinner
                                      animation="border"
                                      role="status"
                                      size="sm"
                                    >
                                      <span className="visually-hidden">
                                        Loading...
                                      </span>
                                    </Spinner>
                                  )}
                                </td>
                                <td>
                                  {isTemplate && (
                                    <>
                                      <div className="flex-gap">
                                        {/* {!fromCheckList && ( */}
                                        <>
                                          <button
                                            type="button"
                                            className="attachmentIcon"
                                            title={t("aces.a11y.edit")}
                                            aria-label={t("aces.a11y.edit")}
                                            onClick={() =>
                                              navigateToEditTemplate(item)
                                            }
                                          >
                                            <i className="ri-edit-line" aria-hidden="true"></i>
                                          </button>
                                          <button
                                            type="button"
                                            className="attachmentIcon"
                                            title={t("aces.a11y.delete")}
                                            aria-label={t("aces.a11y.delete")}
                                            onClick={() => {
                                              if (
                                                window.confirm(
                                                  t("aces.reports.confirmDelete")
                                                )
                                              ) {
                                                deleteCheckList(item.id);
                                              }
                                            }}
                                          >
                                            <i className="ri-delete-bin-6-line" aria-hidden="true"></i>
                                          </button>
                                        </>
                                        {/* )} */}

                                        <button
                                          className="attachmentIcon"
                                          onClick={() =>
                                            navigateToUseTemplate(item)
                                          }
                                          title={t("aces.a11y.useTemplate")}
                                          aria-label={t("aces.a11y.useTemplate")}
                                        >
                                          <i className="ri-link" aria-hidden="true"></i>
                                        </button>
                                      </div>
                                    </>
                                  )}
                                </td>
                              </tr>
                            ))
                          ) : (
                            <tr>
                              <td className="nofound text-center" colSpan={9}>
                                {t("checklist.noChecklistFound")}
                              </td>
                            </tr>
                          )}
                        </tbody>
                      </table>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default CheckList;
